import {
  IonContent,
  IonHeader,
  IonPage,
  IonToolbar,
} from "@ionic/react";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router";
import ExploreContainer from "../../components/formComponents/ExploreContainer/ExploreContainer";
import "./Page.css";
import { Typography } from "@mui/joy";
import HeaderMenu from "../../components/formComponents/Menu/Menu";
import { SESSION_EMAIL_OBLIGATORIO_KEY } from "../../utils/pacienteEmail";

import { FC } from "react";

type PageProps = {
  MenuComponent?: FC<any>;
};

const Page: FC<PageProps> = () => {
  const { name } = useParams<{ name: string }>();
  const history = useHistory();

  useEffect(() => {
    const debeActualizarCorreo =
      sessionStorage.getItem(SESSION_EMAIL_OBLIGATORIO_KEY) === "true";

    if (debeActualizarCorreo && name !== "Datos") {
      history.replace("/portal/Datos");
    }
  }, [history, name]);

  return (
    <>
      <HeaderMenu />
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <Typography level="title-md">{name.toUpperCase()}</Typography>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <IonHeader collapse="condense">
            <IonToolbar>
              <Typography level="title-md">{name.toUpperCase()}</Typography>
            </IonToolbar>
          </IonHeader>
          <ExploreContainer name={name} />
        </IonContent>
      </IonPage>
    </>
  );
};

export default Page;
